export default __webpack_public_path__ + "static/media/naidi-4.20c9be5c.svg";